import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER SESIONES MAS RECIENTES
export const getSesiones = async() => {
    const respuesta = await PrivateInterceptor(`IT/Sesiones`, 'GET')
    return respuesta;
}


export const getActualizacionesApp = async(Fecha1) => {
    const respuesta = await PrivateInterceptor(`IT/Actualizaciones/dispositivos-actualizados`, 'POST', {
        Fecha1: Fecha1
    })
    return respuesta;
}

export const getActualizacionesUsuarios = async (Fecha1) => {
    const result = await PrivateInterceptor('IT/Actualizaciones/usuarios-sesiones', 'POST', {
        Fecha1: Fecha1
    })
    return result;
}